import React, { createContext, useContext, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { configApi } from '@/shared/api/apiEndpoints'
import type { TenantConfig } from '@/types'

const TenantConfigContext = createContext<TenantConfig | null>(null)

export const TenantConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<TenantConfig | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    configApi
      .getTenantConfig()
      .then(setConfig)
      .catch(() => setError(true))
  }, [])

  if (error) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#ff4d4f' }}>
        서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.
      </div>
    )
  }

  if (!config) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="초기화 중...">
          <div style={{ width: 80, height: 80 }} />
        </Spin>
      </div>
    )
  }

  return (
    <TenantConfigContext.Provider value={config}>
      {children}
    </TenantConfigContext.Provider>
  )
}

export const useTenantConfig = (): TenantConfig => {
  const ctx = useContext(TenantConfigContext)
  if (!ctx) throw new Error('TenantConfigProvider가 없습니다.')
  return ctx
}

export const useHasModule = (module: string): boolean => {
  const { modules } = useTenantConfig()
  return modules.includes(module)
}

export const useHasFunction = (fn: string): boolean => {
  const { functions } = useTenantConfig()
  return functions.includes(fn)
}
